import { cssVar } from 'polished'

export const cssVarPolished = (value, fallback = '#222') => {
  return value.includes('var(--') ? cssVar(value.slice(4, -1), fallback) : value
}
